import React from "react";
import { Icons } from "../../shared/Icons";

interface CompleteBudgetModalProps {
  isOpen: boolean;
  budgetLabel: string;
  loading: boolean;
  onCancel: () => void;
  onComplete: () => void;
  onCompleteAndSchedule: () => void;
}

export const CompleteBudgetModal: React.FC<CompleteBudgetModalProps> = ({
  isOpen,
  budgetLabel,
  loading,
  onCancel,
  onComplete,
  onCompleteAndSchedule,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black/50 dark:bg-black/70 transition-opacity backdrop-blur-[1px]" />

      <div className="flex min-h-full items-center justify-center p-2 sm:p-4 text-center">
        <div className="relative transform overflow-hidden rounded-xl sm:rounded-2xl bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-600 px-4 sm:px-6 pb-4 sm:pb-6 pt-4 sm:pt-5 text-left shadow-xl transition-all w-full max-w-lg sm:my-8">
          <div className="flex items-start">
            <div className="mx-auto flex h-10 w-10 sm:h-12 sm:w-12 flex-shrink-0 items-center justify-center rounded-full bg-emerald-100 dark:bg-emerald-950 dark:ring-1 dark:ring-emerald-800 sm:mx-0">
              <Icons.Check sx={{ fontSize: 28 }} className="text-emerald-600 dark:text-emerald-400" />
            </div>
            <div className="mt-0 ml-3 sm:ml-4 flex-1 min-w-0">
              <h3 className="text-base sm:text-lg font-semibold leading-6 text-gray-900 dark:text-white">
                Concluir Orçamento
              </h3>
              <div className="mt-2 space-y-2">
                <p className="text-sm sm:text-base text-gray-500 dark:text-slate-300 break-words">
                  Marcar {budgetLabel} como concluído?
                </p>
                <p className="text-sm text-gray-500 dark:text-slate-400">
                  Você também pode criar agendamentos já preenchidos com cliente,
                  veículo, serviços e valores do orçamento — um agendamento por
                  serviço, em sequência.
                </p>
              </div>
            </div>
          </div>

          <div className="mt-5 flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:justify-end">
            <button
              type="button"
              onClick={onCancel}
              disabled={loading}
              className="inline-flex w-full sm:w-auto justify-center rounded-lg sm:rounded-xl bg-white dark:bg-slate-700 px-4 py-2.5 text-sm font-semibold text-gray-900 dark:text-slate-100 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-slate-500 hover:bg-gray-50 dark:hover:bg-slate-600 disabled:opacity-50"
            >
              Voltar
            </button>
            <button
              type="button"
              onClick={onComplete}
              disabled={loading}
              className="inline-flex w-full sm:w-auto justify-center rounded-lg sm:rounded-xl bg-emerald-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-emerald-500 disabled:opacity-50"
            >
              {loading ? "Processando…" : "Concluir"}
            </button>
            <button
              type="button"
              onClick={onCompleteAndSchedule}
              disabled={loading}
              className="inline-flex w-full sm:w-auto justify-center items-center gap-2 rounded-lg sm:rounded-xl bg-sky-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-sky-500 disabled:opacity-50"
            >
              <Icons.Calendar sx={{ fontSize: 18 }} />
              {loading ? "Processando…" : "Concluir e agendar"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
